/*
 * 设备登记
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取设备信息
    getDeviceList(data) {
        // return get('/app/device_register/customer', data)
        return post('/wx/device/findCustomerDeviceList', data, 'javaHost')
    },
    // 设备详情
    getDeviceDetail(data) {
        // return get('/app/device_register', data)
        return get('/wx/device/findDeviceRegisterList', data, 'javaHost')
    },
    // 设备项详情
    getDeviceItemDetail(data) {
        // return get('/app/device_register/detail', data)
        return get('/wx/device/findDeviceRegisterDetail', data, 'javaHost')
    },

    // 设备项选择项数据
    getSelectItemDeviceList(data) {
        // return get('/app/device_register/get_device', data)
        return get('/wx/device/findSysDeviceList', data, 'javaHost')
    },
    // 添加设备
    addDevice(data) {
        // return post('/app/device_register', data)
        return post('/wx/device/addDeviceRegister', data, 'javaHost')
    },
    // 编辑设备
    updateDevice(data) {
        // return put('/app/device_register/update', data)
        return post('/wx/device/editDeviceRegister', data, 'javaHost')
    },
    // 删除设备
    deleteDevice(data) {
        // return del('/app/device_register/del', data)
        return get('/wx/device/deleteDeviceRegister', data, 'javaHost')
    },
    // 获取建筑信息
    getBuildingInfo(data) {
        // return get('/app/device_register/get_building', data)
        return get('/wx/device/findBuildingInfoList', data, 'javaHost')
    },
    // 获取系统信息
    getSystemInfo(data) {
        // return get('/app/device_register/get_sys', data)
        return get('/firefighting/getSysInfoAll', data, 'javaHost')
    },
    // 修改设备状态
    updateDeviceState(data) {
        // return put('/app/device_register/update_state', data)
        return post('/wx/device/editDeviceRegisterState', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/device.js